import { calculateFare } from '../data/taxiRates';
import { toast } from 'sonner';

// Email notification service (mock - will be replaced with backend API)
export const sendBookingEmail = async (booking, emailType, totalFare) => {
  const { name, email, phone, pickupLocation, dropoffLocation, date, time, passengers } = booking;

  let subject = '';
  let message = '';

  switch (emailType) {
    case 'confirmed':
      subject = `Booking Confirmed - RELAX & RIDE #${booking.id}`;
      message = `
Dear ${name},

Your RELAX & RIDE booking has been CONFIRMED!

BOOKING DETAILS:
━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
Booking ID: RR-${booking.id}
Service: ${booking.service}

PICKUP:
📍 ${pickupLocation}
📅 ${date} at ${time}

DROP-OFF:
📍 ${dropoffLocation}

PASSENGERS: ${passengers}

FARE ESTIMATE:
💰 $${totalFare.toFixed(2)} BSD/USD
   (Base fare + any applicable fees)

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

Your driver has accepted your booking and will arrive at the scheduled time.

IMPORTANT REMINDERS:
• Please be ready at pickup location on time
• Late penalty: $5 per 10 minutes if not ready
• Cancellation within 24hrs: $25 fee

Need to contact us?
📞 +1242-525-8675
✉️ rasrio777@hotmail.com

Thank you for choosing RELAX & RIDE!

Best regards,
RELAX & RIDE Team
Nassau, The Bahamas
      `.trim();
      break;

    case 'on-the-way':
      subject = `Driver On The Way - RELAX & RIDE #${booking.id}`;
      message = `
Dear ${name},

Your RELAX & RIDE driver is now ON THE WAY to pick you up!

PICKUP DETAILS:
━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
📍 Location: ${pickupLocation}
⏰ Scheduled Time: ${time}
👥 Passengers: ${passengers}

FARE:
💰 Total: $${totalFare.toFixed(2)} BSD/USD

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

PLEASE:
✓ Be ready at the pickup location
✓ Have payment ready (cash or card)
✓ Look for your driver's vehicle

Your driver may send you a message with vehicle details or updates.

Questions? Call us at +1242-525-8675

Safe travels!

RELAX & RIDE Team
      `.trim();
      break;

    case 'completed':
      subject = `Trip Completed - RELAX & RIDE #${booking.id}`;
      message = `
Dear ${name},

Thank you for riding with RELAX & RIDE!

TRIP SUMMARY:
━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
From: ${pickupLocation}
To: ${dropoffLocation}
Fare: $${totalFare.toFixed(2)} BSD/USD
━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

We hope you had a pleasant journey!

Please consider leaving us a review on our website.

We look forward to serving you again soon.

Best regards,
RELAX & RIDE Team
📞 +1242-525-8675
✉️ rasrio777@hotmail.com
      `.trim();
      break;

    default:
      return;
  }

  // Mock email sending - in production, this would call backend API
  const emailData = {
    to: email || phone, // fallback to phone if no email
    subject,
    message,
    bookingId: booking.id,
    timestamp: new Date().toISOString()
  };

  // Store in localStorage for demo purposes
  const sentEmails = JSON.parse(localStorage.getItem('sentEmails') || '[]');
  sentEmails.push(emailData);
  localStorage.setItem('sentEmails', JSON.stringify(sentEmails));

  // Log to console (in production, this would be API call)
  console.log('📧 EMAIL SENT:', emailData);

  // Show toast notification
  toast.success(`Email sent to ${name}`, {
    description: subject
  });

  return emailData;
};

// Calculate total fare for a booking
export const calculateBookingFare = (booking) => {
  const fare = calculateFare(
    booking.pickupLocation,
    booking.dropoffLocation,
    parseInt(booking.passengers) || 2,
    0 // extra bags - would need to be added to booking form
  );

  return fare.found ? fare.total : 0;
};

// Get all sent emails for a booking
export const getBookingEmails = (bookingId) => {
  const sentEmails = JSON.parse(localStorage.getItem('sentEmails') || '[]');
  return sentEmails.filter(email => email.bookingId === bookingId);
};
